import { SHIFT_AND_REPORTS_VIEW_PERMISSION } from '@/constants/permissions'

export default [
    {
        path: '/shift-and-reports',
        name: 'ShiftAndReports',
        meta: {
            permission: [SHIFT_AND_REPORTS_VIEW_PERMISSION],
            isForeman: true,
        },
        component: () => import('./views/ShiftAndReports.vue'),
    },
]